import type { DTOClientProperties } from 'src/apis/dto/DTOClientProperties';

import type { APIClientType } from '.';

export type SessionAccessTrigger = 'load' | 'reload' | 'resume';
export type DisplayMode = 'standalone' | 'browser';

export interface SessionAccessRequest {
  deviceId: string;
  clientProperties: DTOClientProperties;
  trigger: SessionAccessTrigger;
  webContext: {
    displayMode: DisplayMode;
  };
}

export class SessionAccessService {
  private client: APIClientType;

  constructor(customClient: APIClientType) {
    this.client = customClient;
  }

  public reportAccess = async (request: SessionAccessRequest) => {
    return this.client.call<void, SessionAccessRequest>({
      method: 'POST',
      path: '/api/v1/session/access',
      data: request,
    });
  };
}
